import { useCallback, useContext, useEffect, useState } from "react";
import { authorOption, robotsOption, statusOption } from "../../../constant";
import { useService } from "../../../hooks";
import { NavigatorContext } from "../../../context";

export const useProject = () => {
  const { navigateTo } = useContext(NavigatorContext);
  const { fetchByAttr } = useService("Data", "project");
  const { setTitle } = useService("Meta");
  const { isEmpty } = useService("Misc");
  const { urlToSplitData, getLocationData } = useService("Router");
  const [, setactiveRobotsIndex] = useState<number>(0);
  const [, setactiveStatusIndex] = useState<number>(0);
  const [, setactiveAuthorIndex] = useState<number>(0);
  const [image, setimage] = useState<string>("[]");
  const [title, settitle] = useState<string>("");
  const [slug, setslug] = useState<string>("");
  const [description, setdescription] = useState<string>("");
  const [releaseDate, setreleaseDate] = useState(new Date());
  const [, setmetaKeyword] = useState(null);
  const [category, setcategory] = useState([]);
  const [, settag] = useState(null);

  const urlData = urlToSplitData(getLocationData().pathname);
  const urlSlug = urlData[2];

  const getProjectData = useCallback(async (query) => {
    const result = await fetchByAttr(query);
    if (result.status) {
      if (result.data[0].status !== "release")
        navigateTo({ route: "/error404" });
      else {
        const projectData = result.data[0];
        setactiveAuthorIndex(
          authorOption.findIndex((e) => e.value === projectData.robots)
        );
        setactiveRobotsIndex(
          robotsOption.findIndex((e) => e.value === projectData.robots)
        );
        setactiveStatusIndex(
          statusOption.findIndex((e) => e.value === projectData.status)
        );
        settag(isEmpty(projectData.tag) ? [] : JSON.parse(projectData.tag));
        setcategory(
          isEmpty(projectData.category) ? [] : JSON.parse(projectData.category)
        );
        setmetaKeyword(
          isEmpty(projectData.metaKeyword)
            ? []
            : JSON.parse(projectData.metaKeyword)
        );
        setTitle(projectData.title);
        settitle(projectData.title);
        setslug(projectData.slug);
        setdescription(projectData.description);
        setreleaseDate(new Date(projectData.releaseDate));
        setimage(projectData.image);
      }
    }
  }, [fetchByAttr, isEmpty, navigateTo, setTitle]);

  useEffect(() => {
    if (slug !== urlSlug) getProjectData({ slug: urlSlug });
  }, [slug, urlSlug, getProjectData]);
  return {
    title,
    releaseDate,
    image,
    slug,
    description,
    category: category.join(", "),
  };
};
